<template>
  <div class="register-body">
    <a-spin>
      <a-icon v-show="loading" slot="indicator" type="loading" style="font-size: 24px" spin>{{ $t('auth.register.registering') }}</a-icon>
    </a-spin>
    <h4>{{$t('scope.text_348')}}</h4>
    <register-by-oauth :params="oauthParams" :idps="idps" @register="handleRegister" v-if="isLinkAccount" />
    <a-tabs default-active-key="mobile" v-else>
      <a-tab-pane key="mobile" :tab="$t('scope.text_200')">
        <register-by-mobile @register="handleRegister" />
      </a-tab-pane>
      <a-tab-pane key="email" :tab="$t('scope.text_204')">
        <register-by-email @register="handleRegister" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RegisterByEmail from './RegisterByEmail'
import RegisterByMobile from './RegisterByMobile'
import RegisterByOauth from './RegisterByOauth'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'Register',
  components: {
    RegisterByEmail,
    RegisterByMobile,
    RegisterByOauth,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      loading: false,
      enableSendSmsCode: false,
      startCountDown: false,
      count: 60,
      timer: null,
      disabled: true,
    }
  },
  computed: {
    ...mapGetters(['logo']),
    ...mapGetters('auth', ['regions']),
    idps () {
      return this.regions.idps || []
    },
    isLinkAccount () {
      if (this.$route.query.error_class !== 'UserNotFound') return false
      if (!this.$route.query.idp_entity_id) return false
      if (!this.$route.query.idp_id) return false
      return !!this.$route.query.idp_nonce
    },
    oauthParams () {
      return {
        idp_entity_id: this.$route.query.idp_entity_id,
        idp_id: this.$route.query.idp_id,
        idp_nonce: this.$route.query.idp_nonce,
      }
    },
  },
  methods: {
    handleRegister (state) {
      this.loading = state
    },
  },
}
</script>

<style lang="less" scoped>
.logo {
  text-align: right;
  img {
    height: 40px;
  }
}
h4 {
  margin-top: 20px;
  margin-bottom: 40px;
}
.register-body {
  width: 570px;
  height: 680px;
  position: relative;
  background-color: #fff;
  padding: 40px;
  ::v-deep {
    .ant-input-group-addon {
      border: 0;
    }
  }
}
</style>
